import React from 'react';
import $ from "jquery";
import {Modal, Button} from 'react-bootstrap';

import { sendRequest, authUrl } from './global.js';
import Storage, {T} from './Storage.js';

import FlexibleInput from './FlexibleInput.js';

export default class ObjectEditView extends React.Component {

  constructor(props) {
    super(props);
    this.state = this.getDefaultState(props);
  }
  
  getDefaultState = (props) => {
    props = props || this.props;
    var properties = Object.assign({}, Storage.getConfig(props.configKey).properties);
    var config = Storage.getConfig(props.configKey).config;
    var keys = Object.keys(properties);
    var object = {};
    for (let i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (props.object && props.object[key]) {
        object[key] = props.object[key];
      } else {
        if (Array.isArray(properties[key].default)) {
          object[key] = properties[key].default.slice();
        } else if (typeof properties[key].default === "object") {
          object[key] = Object.assign({}, properties[key].default);
        } else {
          object[key] = properties[key].default;
        }
      }
    }
    if (typeof config.extra_fields !== "undefined") {
      if (typeof config.extra_fields.method !== "undefined") {
        var data = {};
        if (object.id) {
          data[config.extra_fields.objectParameter] = object.id;
        }
        sendRequest({
          method: config.extra_fields.method,
          type: "GET",
          data: data,
          success: (data) => {
            var object = this.state.object;
            var newProps = Object.assign({}, this.state.properties);
            for (let i = 0; i < data.length; i++) {
              var key = "extra" + data[i].id; 
              newProps[key] = {
                default: "", 
                type: "text",
                title: data[i].name,
                preset: false,
                id: data[i].id,
                request: config.extra_fields.request,
                idParameter: config.extra_fields.idParameter
              };
              if (typeof object[key] === "undefined") {
                object[key] = ""; 
              }
            }
            this.setState({properties: newProps, object: object});
          },
          error: (xhr, status, err) => {
          }
        });  
      }
    }
    var state = {
      object: object, 
      edit: props.edit,
      properties: properties, 
      config: config,
      responseContent: false,
    }
    return state;
  }

  componentWillReceiveProps = (props) => {
    if (props.configKey) {
      if (props.configKey !== this.props.configKey || props.object.id !== this.props.object.id) {
        var state = this.getDefaultState(props);
        this.setState(state);
        this.requestInitialData(state);
      } else if (props.edit !== this.props.edit) {
        this.setState({edit: props.edit});
      }
    }
  }

  updateStateWithData = (data) => {
    var keys = Object.keys(this.state.properties);
    var object = this.state.object;
    var properties = this.state.properties;
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      if (typeof data[key] !== "undefined" && data[key] !== null) {
        object[key] = data[key];
      }
    }
    var extra = this.state.config.extra_fields;
    if (typeof extra !== "undefined") {
      for (let i = 0; i < data[extra.parameter].length; i++) {
        object["extra" + data[extra.parameter][i].id] = data[extra.parameter][i].value;
      }
    }
    var variable = this.state.config.variable_fields;
    if (typeof variable !== "undefined") {
      for (let i = 0; i < data[variable.parameter].length; i++) {
        let key = "variable" + i;
        var title = data[variable.parameter][i].name;
        if (typeof title === "undefined") {
          title = variable.translations[data[variable.parameter][i].field];
        }
        object[key] = {
          from: data[variable.parameter][i].from_value,
          to: data[variable.parameter][i].to_value
        };
        properties[key] = {
          default: "", 
          type: "change",
          title: title,
          preset: true
        };
      }
    }
    this.setState({object: object, properties: properties});
  }

  componentDidMount = () => {
    this.requestInitialData();
  }

  requestInitialData = (state) => {
    state = state || this.state;
    if (!state.object.id) {
      return;
    }
    sendRequest({
      method: state.config.method + state.object.id,
      type: "GET",
      success: (data) => {
        this.updateStateWithData(data);
      },
      error: (xhr, status, err) => {
      }
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    var sendData = {};
    var extra = this.state.config.extra_fields;
    if (typeof extra !== "undefined") {
      sendData[extra.parameter] = [];
      var keys = Object.keys(this.state.object);
      for (let i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (key.match(/extra/)) {
          sendData[extra.parameter].push({
            id: this.state.properties[key].id, 
            value: this.state.object[key],
          });
        } else {
          sendData[key] = this.state.object[key]; 
        }
      }
    } else {
      sendData = this.state.object;
    }
    sendRequest({
      method: this.state.config.method + (this.state.object.id ? this.state.object.id : ""),
      type: this.state.object.id ? "PUT" : "POST",
      data: sendData,
      success: (data) => {
        this.updateStateWithData(data);
        this.handleFinishEdit();
      },
      error: (xhr, status, err) => {
      }
    });
  }

  handleFinishEdit = () => {
    $(document).trigger("changePage", [this.props.configKey]);
  }

  handleEdit = (e) => {
    e.preventDefault();
    $(document).trigger("changePage", [this.props.configKey, this.state.object, "edit"]);
  }

  handlePropertyChange = (key, value) => {
    var object = this.state.object;
    object[key] = value;
    this.setState({object: object});
  }

  onEditLinkClick = (e) => {
    var prefix = this.state.config.method;
    var sufix = this.state.config.edit_link.sufix;
    var id = this.state.object.id;
    var url = authUrl(prefix + id + sufix);
    window.open(url, '_blank');
  }

  onReportClick = (e, key) => {
    var report = this.state.config.singleReport[key];
    sendRequest({
      method: report.request,
      type: report.type,
      data: {id: this.state.object.id},
      success: (data) => {
        this.setState({responseContent: data});
      }
    });
  }

  onModalClose = () => {
    this.setState({responseContent: false});
  }

  render = () => {
    var inputs = Object.keys(this.state.properties).map((key) => { // eslint-disable-line
      if (this.state.properties[key].type !== "none") {
        let groupHidden = this.state.properties[key].preset && !this.state.object.id;
        if (this.state.properties[key].adminGroup) {
          const adminGroup = !!((this.props.user || {}).user_group || {}).admin;
          if (!adminGroup) {
            groupHidden = true;
          }
        }
        let inputDisabled = this.state.properties[key].preset 
          || (!this.state.edit && this.state.object.id > 0)
          || (this.state.edit && this.state.properties[key].createOnly);
        let hostProp = this.state.properties[key].hostProperty;
        return (
          <div className="form-group" hidden={groupHidden} key={key}>
            <label htmlFor="id" className="col-sm-2 control-label">{this.state.properties[key].title}</label>
            <div className="col-sm-10">
              <FlexibleInput
                object={this.state.object[key]}
                parentId={this.state.object.id}
                configKey={this.props.configKey}
                onChange={this.handlePropertyChange}
                disabled={inputDisabled}
                objectKey={key}
                objectProperties={this.state.properties}
                hostPropertyValue={hostProp ? this.state.object[hostProp] : null}
              />
            </div>
          </div>
        );
      }
    });

    var viewType = !this.state.object.id ? T("title_create") : this.state.edit ? T("title_edit") : T("title_view");
    
    var actionButton = null;
    if (this.state.object.id && !this.state.edit) {
      actionButton =
        <button 
          className="btn button-edit" 
          onClick={this.handleEdit}
        >{T("button_edit")}</button>
    } else {
      actionButton = 
        <button 
          type="submit" 
          value="Post" 
          className="btn btn-primary"
        >{T("button_save")}</button>
    }
    if (this.state.config.preset) {
      actionButton = null;
    }
    if (this.state.object.deleted) {
      actionButton = 
      <button 
        className="btn button-delete"
        disabled={true}
      >{T("button_deleted")}</button>
    }

    var editLinkButton = null;
    if (typeof this.state.config.edit_link !== "undefined" && this.state.edit) {
      editLinkButton = 
      <div className="form-group">
        <div className="col-sm-offset-2 col-sm-10">
          <a 
            className="btn btn-default"
            onClick={this.onEditLinkClick}
          >{this.state.config.edit_link.title}</a>
        </div>
      </div>
    }

    var singleReportButtons = null;
    if (this.state.config.singleReport) {
      singleReportButtons = Object.keys(this.state.config.singleReport).map((key) => { // eslint-disable-line
        let report = this.state.config.singleReport[key];
        if (report.showCondition(this.state.object)) {
          return(
            <button 
              key={key}
              className="btn button-report"
              onClick={(e) => {this.onReportClick(e, key)}}
            >{report.button}</button>
          );
        }
      });
    }

    return (
      <div className="adminContent customScrollBar">

        <div className="reportButtons">
          {singleReportButtons}
        </div>
        <h1 className="page-header">
          <a onClick={this.handleFinishEdit}>
            <i className="fa fa-angle-left" aria-hidden="true"></i>
          </a>
          {this.state.config.objectName} - {viewType}
        </h1>
        <form className="form-horizontal" onSubmit={this.handleSubmit}>
          {inputs}
          {editLinkButton}
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              {actionButton}
            </div>
          </div>
        </form>

        <Modal show={!!this.state.responseContent} onHide={this.onModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>{T("modal_response_title")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span className="errorMessage">{this.state.responseContent.error}</span>
            {this.state.responseContent.message}
            <br/>
            <a href={this.state.responseContent.link} target="_blank">{this.state.responseContent.link ? T("modal_response_link") : ""}</a>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onModalClose}>{T("button_close")}</Button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/ObjectEditView.js